import React from "react";
import CustomColumnRenderers from "components/events/events/ColumnRenderers";
const RemediationSteps = ({ event, meta, eventDefinitionEventProcedureId }) => /* @__PURE__ */ React.createElement("div", null, CustomColumnRenderers.attributes.remediation_steps.renderCell(
  void 0,
  event,
  meta,
  eventDefinitionEventProcedureId
));
export default RemediationSteps;
